import React, { useEffect, useMemo } from "react";
import { ResearchId } from "../../../adapters/deep-research/state/AppState.ts";
import {
  useMessagesState,
  useReferencesState,
  useResearchState,
} from "../../../adapters/deep-research/state/hooks/stateHooks.ts";
import { useDeepResearchService } from "../../../adapters/deep-research/state/hooks/useDeepResearchService.tsx";
import { useFeatureFlagValue } from "../../../config/FeatureFlagManager/hooks.ts";
import { ReferenceSidebar } from "../../../feature-components/ReferenceSidebar/ReferenceSidebar.tsx";

const useFlags = (): { enableRemoveFiles: boolean } => {
  const enableRemoveFiles = useFeatureFlagValue("enableRemoveFiles");
  return useMemo(() => ({ enableRemoveFiles }), [enableRemoveFiles]);
};

export const ConnectedReferencesSidebar: React.FC<{
  researchId: ResearchId;
}> = (props) => {
  const { researchId } = props;
  const appService = useDeepResearchService();
  const research = useResearchState(researchId);
  const messages = useMessagesState(researchId);
  useEffect(() => {
    if (research?.status === "completed") {
      appService.refreshFileReferences({ researchId }).then();
    }
  }, [appService, research?.status, researchId, messages]);
  const featureFlags = useFlags();
  const references = useReferencesState(researchId);
  return (
    <ReferenceSidebar
      references={references}
      pendingSummary={research?.status !== "completed"}
      onRemoveReferences={(referenceIds) => {
        return appService.removeReferences({ researchId, referenceIds });
      }}
      researchId={research?.id}
      featureFlags={featureFlags}
    />
  );
};
